import { Box } from '@chakra-ui/react'
import {
  getValidUrl,
  isHBSite,
  PopulatedThreadMessage,
  splitTextLines,
  splitTextParts,
} from '@hb/shared'
import { useMemo } from 'react'

import { LinkPreview } from '../../../shared/SiteLink'

export const MessageLinkPreview = ({ message }: { message: PopulatedThreadMessage }) => {
  const { text } = message ?? {}
  const firstLinkUrl = useMemo(() => {
    if (!text) return null
    const lines = splitTextLines(text ?? '')
    for (const line of lines) {
      const parts = splitTextParts(line)
      const [firstLink] = parts.map(p => getValidUrl(p)).filter(link => link && !isHBSite(link))
      if (firstLink) return firstLink
    }
    return null
  }, [text])

  if (!firstLinkUrl) return null

  return (
    <Box maxW="100%" pb={1}>
      <LinkPreview href={firstLinkUrl} />
    </Box>
  )
}
